module.exports = __webpack_public_path__ + "static/media/amazon.8f2be3f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/imgs/amazon.png
// module id = 205
// module chunks = 0